// @ts-nocheck

import React, { Dispatch, FC, SetStateAction, useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import useWeb3 from '../../../hooks/useWeb3'
import {
  selectAccount,
  selectBalance,
  selectBalanceEth,
  selectBalanceLPT,
  selectIsEthRaise,
} from '../../../modules/web3/selectors'
import { formatAccountAbbreviation } from '../../../shared_components/ConnectedWallet'
import { Box } from '../../../shared_components/UI/Box'
import { defaultTransition } from '../../../theme'
import { amountFromWei } from '../../../utils/amount'
import { numberWithCommas } from '../../../utils/commaSeperators'
import { getRgbaValue } from '../../../utils/styling'
import { MethodBox, NoticeBox } from './styles'

// import transakSDK from '@transak/transak-sdk'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { QUICKSWAP_LINK, USDB_DECIMALS } from '../../../config'

const { REACT_APP_TRANSAK_API_KEY: TRANSAK_API_KEY, REACT_APP_NETWORK } =
  process.env || {}

interface Props {
  isFiat?: boolean
  setIsFiat?: Dispatch<SetStateAction<boolean>>
  isIons?: boolean
  requiresTopup?: boolean
}

const Container = styled(Box)`
  flex-direction: column;
  margin-top: 32px;
  .quickswap {
    flex: 0;
    margin-right: 16px;
  }
  .mobile-top-margin {
    @media (max-width: 1000px) {
      margin-top: 8px;
    }
  }
`

export const ClaimButton = styled.button<{
  hasClaimed?: boolean
  isAllClaim?: boolean
  alignLeft?: boolean
  customWidth?: number
  hollowDisabled?: boolean
  lessPadding?: boolean
}>`
  justify-content: center;
  align-items: center;
  display: flex;
  width: ${({ customWidth }) => customWidth ?? 103}px;
  height: 48px;
  left: 1149px;
  top: 27px;
  padding: 0px ${({ lessPadding }) => (lessPadding ? 16 : 32)}px;
  margin-left: ${({ alignLeft }) => (alignLeft ? 0 : 16)}px;
  ${({ isAllClaim }) =>
    isAllClaim &&
    css`
      margin-right: 20px;
    `}
  background: ${({ theme }) => theme.colors.brandPrimary};
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: black;
  :disabled {
    cursor: not-allowed;
    border: 1px solid #222326;
    ${({ hollowDisabled, theme }) =>
      hollowDisabled && theme.isDark
        ? css`
            filter: saturate(0);
            opacity: 0.8;
            background: transparent;
            :disabled {
              color: white;
            }
            :hover {
              color: black;
            }
          `
        : css`
            filter: saturate(0);
            opacity: 0.2;
            background: #030303;
            :hover {
              background: #030303;
            }
          `}
  }

  :hover {
    background: ${({ theme, hasClaimed }) =>
      hasClaimed ? 'transparent' : theme.colors.brandPrimary};
  }
  @media screen and (max-width: 600px) {
    width: ${({ hasClaimed }) => (hasClaimed ? '71px' : '100%')};
  }
  ${({ hasClaimed }) =>
    hasClaimed
      ? css`
          padding: 4px 10px;
          width: 71px;
          height: 20px;
          /* background:black; */
          background: ${(props: any) =>
            props.theme.isDark ? '#0F0F11' : '#ddd'};
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 12px;
          text-transform: uppercase;
          font-feature-settings: 'ss01' on;
          color: #3d68ff;
        `
      : ''}
`

export const ToggleButton = styled.button<{ isActive: boolean }>`
  margin-right: 24px;
  position: relative;
  min-width: 24px;
  min-height: 24px;
  border-radius: 250px;
  border: 1px solid
    ${({ isActive, theme }) =>
      !isActive
        ? getRgbaValue(theme.semantics.zap.surface.primary, 0.3)
        : '#3d68ff'};
  z-index: 1;
  :after {
    content: '';
    top: 4px;
    left: 4px;
    position: absolute;
    width: 14px;
    height: 14px;
    background: #3d68ff;
    border-radius: 250px;
    z-index: 2;
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    ${defaultTransition}
  }
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
  @media (max-width: 1000px) {
    margin-right: 12px;
  }
`

const ButtonsContainer = styled(Box)`
  margin-top: 32px;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    button {
      margin: 16px 0;
      width: 100%;
    }
  }
`

const ConnectButton = styled.button<{
  isWhite?: boolean
  lessPaddingMobile?: boolean
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px ${({ lessPadding }) => (lessPadding ? 12 : 24)}px;
  gap: 10px;
  min-width: 212px;
  height: 48px;
  background: ${({ isWhite }) => (isWhite ? '#ffffff' : '#3A99FB')};
  color: ${({ isWhite }) => (isWhite ? '#0E0E10' : 'white')};
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-right: 12px;
  img {
    margin-right: 12px;
  }
  :hover {
    background: #444;
    color: white;
  }
  @media (max-width: 1000px) {
    padding: 0px ${({ lessPaddingMobile }) => (lessPaddingMobile ? 12 : 24)}px;
  }
`

const BalanceContainer = styled(Box)`
  flex-direction: column;
  margin-left: auto;
  width: 100%;
  flex: 2;
  align-items: flex-end;
  text-align: right;
  strong {
    text-transform: uppercase;
    font-family: 'Space Grotesk';
  }
  span.wallet-label {
    font-size: 12px;
    line-height: 15px;
    opacity: 0.5;
    text-transform: uppercase;
    margin-right: 4px;
    margin-top: 8px;
  }
  span.change-wallet {
    font-family: 'Space Grotesk';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    text-decoration-line: underline;
    color: #3d68ff;
    cursor: pointer;
    margin-top: -1px;
  }
  @media screen and (max-width: 1000px) {
    text-align: left;
    align-items: flex-start;
    margin-top: 16px;
  }
`

const PoweredBy = styled.span`
  font-size: 11px !important;
  line-height: 15px;
  text-transform: uppercase;
  opacity: 0.5;
  margin-right: 14px;
`

const TransakWidget = styled.iframe`
  margin: 32px auto;
  display: block;
  width: 100%;
  min-height: 625px;
  max-width: 500px;
`

const Balance = styled.span``

const isMainnet = REACT_APP_NETWORK === 'mainnet'

const PaymentMethods: FC<Props> = ({
  isFiat = false,
  setIsFiat,
  isIons = false,
  requiresTopup = false,
}) => {
  const { initWeb3 } = useWeb3()
  const account = useSelector(selectAccount)
  const balanceInUsdb = useSelector(selectBalance)
  const balanceIons = useSelector(selectBalanceLPT)
  const balanceInEth = useSelector(selectBalanceEth)
  const isEthRaise = useSelector(selectIsEthRaise)
  const balance = isEthRaise ? balanceInEth : balanceInUsdb

  const { width: windowWidth } = useWindowSize()

  const hasAccount = account !== '' && account

  const ConnectWalletButtons = () => (
    <ButtonsContainer align="center">
      <ConnectButton isWhite onClick={() => initWeb3()}>
        <img src="/img/icons/metamask.png" alt="metamask logo" />
        Connect MetaMask
      </ConnectButton>
      <ConnectButton lessPaddingMobile onClick={() => initWeb3()}>
        <img src="/img/icons/walletconnect.svg" alt="walletconnect logo" />
        Connect Connect
      </ConnectButton>
    </ButtonsContainer>
  )

  useEffect(() => {
    if (account && account !== '' && isFiat) {
      // let transak = new transakSDK({
      //   apiKey: TRANSAK_API_KEY,
      //   environment: isMainnet ? 'PRODUCTION' : 'STAGING',
      //   hostURL: window.location.origin,
      //   widgetHeight: '625px',
      //   widgetWidth: windowWidth > 500 ? '500px' : `${windowWidth}px`,
      //   cryptoCurrencyCode: 'USDC',
      //   network: 'polygon',
      //   walletAddress: account,
      //   fiatCurrency: '',
      // })
      // transak.init()
      // // To get all the events
      //
      // const onEnd = () => {
      //   transak.close()
      //   setIsFiat(false)
      // }
      // // This will trigger when the user marks payment is made.
      // transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData: any) => {
      //   onEnd()
      // })
      //
      // transak.on(transak.EVENTS.TRANSAK_WIDGET_CLOSE, (orderData) => {
      //   onEnd()
      // })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, isFiat, setIsFiat])

  const ButtonWrap = ({ children }) =>
    isIons ? (
      <a
        href={QUICKSWAP_LINK}
        target="_blank"
        rel="noreferrer"
        className="mobile-top-margin"
      >
        {children}
      </a>
    ) : (
      <>{children}</>
    )

  return (
    <Container>
      <MethodBox>
        <Box align="center" justify="space-between" className="mobile-col">
          <Box align="center" justify="flex-start" flex={1}>
            <ToggleButton isActive={!isFiat} onClick={() => setIsFiat(false)} />
            <span>
              {isIons ? 'Use IONs in crypto wallet' : 'Pay with crypto wallet'}
            </span>
          </Box>
          {hasAccount && (
            <BalanceContainer>
              <Balance>
                {isEthRaise
                  ? amountFromWei(balance, 18).toFixed(5)
                  : numberWithCommas(
                      amountFromWei(balance, USDB_DECIMALS).toNumber(),
                    )}{' '}
                {isEthRaise ? 'ETH' : isIons ? 'IONs' : 'USDB'}{' '}
                <strong>available</strong>
              </Balance>
              <Box
                justify="flex-end"
                align="center"
                className="mobile-col mobile-start"
              >
                <span className="wallet-label">
                  paying with {formatAccountAbbreviation(account)}
                </span>
              </Box>
            </BalanceContainer>
          )}
        </Box>
        {!hasAccount && !isFiat && <ConnectWalletButtons />}
      </MethodBox>
      {!isIons ||
        (isIons && requiresTopup && (
          <NoticeBox>
            <Box align="flex-start" className={isIons ? '' : 'mobile-col'}>
              {isIons && (
                <img
                  className="ions-logo"
                  src="/img/icons/lithium-plus/ions-purple.svg"
                  alt="ions logo"
                />
              )}
              <Box direction="column" marginBottom={16}>
                <span className="pad-bottom">
                  {isIons
                    ? 'You’ll need to purchase more IONs for this plan '
                    : 'Top up wallet with fiat (60+ supported currencies)'}
                </span>
                <ButtonWrap>
                  <ClaimButton
                    alignLeft
                    customWidth={140}
                    lessPadding={isIons}
                    className={isIons ? 'quickswap-button' : ''}
                    onClick={() => !isIons && setIsFiat(true)}
                  >
                    {isIons ? (
                      <Box align="center" justify="flex-start">
                        <img
                          className="quickswap"
                          src="/img/icons/lithium-plus/quickswap-logo.svg"
                          alt="quickswap logo"
                        />
                        <span>Buy on Quickswap</span>
                      </Box>
                    ) : (
                      'Get USDC'
                    )}
                  </ClaimButton>
                </ButtonWrap>
              </Box>
              {!isIons && (
                <Box justify="flex-end" flex={2}>
                  <PoweredBy>Powered By</PoweredBy>
                  <img src="/img/logos/transak.svg" alt="Transak logo" />
                </Box>
              )}
            </Box>
            {isFiat && <>{!hasAccount && <ConnectWalletButtons />}</>}
          </NoticeBox>
        ))}
    </Container>
  )
}

export default PaymentMethods
